"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  rpc: {
    testMultiply2: {
      description: 'Test type of Balance',
      params: [{
        name: 'amount',
        type: 'String'
      }, {
        name: 'at',
        type: 'BlockHash',
        isOptional: true
      }],
      type: 'Option<CustomInfo>'
    }
  },
  types: {
    CustomInfo: {
      amount: 'Balance'
    }
  }
};
exports.default = _default;